import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorHelpCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M11.25 3.75a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm-9 7.5a9 9 0 1 1 18 0 9 9 0 0 1-18 0Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M16.72 16.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06Z"
    />
    <path
      fill="#F7A600"
      d="M9.75 9.75a1.5 1.5 0 0 1 3 0v.45c0 .58-.47 1.05-1.05 1.05a.95.95 0 0 0-.95.95v1.3a.75.75 0 0 0 1.5 0v-.81a2.55 2.55 0 0 0 2-2.49v-.45a3 3 0 1 0-6 0v.435a.75.75 0 0 0 1.5 0V9.75ZM11.5 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
);
export default SvgTwoColorHelpCenter;
